import React, { FC } from "react";

import { StyledForm, StyledModal } from "features/Admin/admin.style";
import { Button, Form, Input, ModalProps } from "antd";

import useCreateNewRecord from "common/hooks/useCreateNewRecord";
import { onSubjectCreate } from "services/subject/subject.service";
import { subjectActions } from "redux/reducers/subject.redux";

import { SubjectData, SubjectModel } from "services/subject/subject.model";
import SelectGroup from "features/Admin/Groups/widgets/SelectGroup";
import SelectInstructor from "features/Admin/Instructors/widgets/SelectInstructor";
import SelectDepartment from "features/Admin/Departments/widgets/SelectDepartment";

export interface SubjectCreateModalProps extends ModalProps {
	closeModal: () => void;
}

const SubjectCreateModal: FC<SubjectCreateModalProps> = ({
	closeModal,
	...otherProps
}) => {
	const { form, formStatus, createRecord, error } = useCreateNewRecord<
		SubjectData,
		SubjectModel
	>({
		serviceFunction: onSubjectCreate,
		action: subjectActions.appendSubjects,
		onRecordCreated: () => {
			closeModal();
		},
	});

	const onOk = () => {
		form.submit();
	};

	const onCancel = (e: any) => {
		closeModal();
	};

	return (
		<StyledModal
			{...otherProps}
			onCancel={onCancel}
			title="Create Subject"
			width={400}
			onOk={onOk}
			centered
			footer={null}
		>
			<StyledForm
				form={form}
				onFinish={(values) => {
					createRecord(values as SubjectData);
				}}
				layout="vertical"
			>
				<Form.Item
					name="subjectName"
					label="Name"
					rules={[
						{
							required: true,
							message: "Subject name is required.",
						},
					]}
				>
					<Input type="text" />
				</Form.Item>
				<Form.Item
					name="subjectCode"
					label="Code"
					rules={[
						{
							required: true,
							message: "Subject code is required.",
						},
					]}
				>
					<Input type="text" />
				</Form.Item>

				<SelectGroup />
				<SelectDepartment />
				<SelectInstructor />

				{error && <p className="error">{error}</p>}
				<Form.Item>
					<Button
						style={{ width: "100%" }}
						type="primary"
						htmlType="submit"
						loading={formStatus === "loading"}
					>
						{formStatus === "loading" ? "Creating" : "Create"}
					</Button>
				</Form.Item>
			</StyledForm>
		</StyledModal>
	);
};

export default SubjectCreateModal;
